import { api } from "./api";

/**
 * CRM-style planned activities (call log + planned events) for a
 * construction row. Distinct from the immutable timeline
 * (`/construction/{id}/activities`) — this is the "Aktiviteler" tab
 * inspired by the ExproCRM UX.
 */
export const plannedActivitiesApi = {
  list: (constructionId, params = {}) =>
    api.get(`/construction/${constructionId}/planned-activities`, { params }).then((r) => r.data),

  counts: (constructionId) =>
    api.get(`/construction/${constructionId}/planned-activities/counts`).then((r) => r.data),

  create: (constructionId, payload) =>
    api.post(`/construction/${constructionId}/planned-activities`, payload).then((r) => r.data),

  update: (activityId, patch) =>
    api.patch(`/planned-activities/${activityId}`, patch).then((r) => r.data),

  remove: (activityId) =>
    api.delete(`/planned-activities/${activityId}`).then((r) => r.data),

  // Current-user aggregation for the Dashboard widget.
  // scope: "upcoming" (default), "all", "delegated"
  mine: (params = {}) =>
    api.get(`/my-planned-activities`, { params }).then((r) => r.data),

  // Scope counts for smart-default tab selection.
  mineCounts: () =>
    api.get(`/my-planned-activities/counts`).then((r) => r.data),
};

export const callOutcomesApi = {
  list: () => api.get("/call-outcomes").then((r) => r.data),
  create: (payload) => api.post("/call-outcomes", payload).then((r) => r.data),
  remove: (outcomeId) => api.delete(`/call-outcomes/${outcomeId}`).then((r) => r.data),
};
